import React from "react";

import { Modal } from "../Modal";
import { useModalContext } from "../../contexts/ModalContext/context";
import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { dayjs } from "../../services/dayjs";
import { Box } from "../../UI/Box";

interface IProps {
  date?: dayjs.Dayjs;
  onClose: VoidFunction;
  handleRequest: (notify: boolean) => void;
  l2Name: string;
  isLoading?: boolean;
  isPrevEndDateSelected?: boolean;
  usersInNetwork: number;
}

export const ClosedDateChangeNotificationModal: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();
  const [isConfirmView, setIsConfirmView] = React.useState(props.isPrevEndDateSelected);
  // const [isConfirm, setIsConfirm] = React.useState(false);
  // const [notify, setNotify] = React.useState(false);

  React.useEffect(() => {
    setIsConfirmView(props.isPrevEndDateSelected);
  }, [props.isPrevEndDateSelected]);

  const handleClose = () => {
    setIsOpen(false);
    props.onClose();
  };

  const handleOk = () => {
    // if (!isConfirmView) {
    //   props.handleRequest(notify);
    //
    //   if (!notify) {
    //     setIsOpen(false);
    //   }
    //
    //   return;
    // }
    //
    // if (isConfirm) {
    //   setIsConfirmView(false);
    //   return;
    // }

    props.handleRequest(false);
    setIsOpen(false);
    // handleClose();
  };

  // const handleNotifyChange = (event: React.ChangeEvent<HTMLInputElement>) => setNotify(event.target.name === "yes");
  //
  // const handleConfirmChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setIsConfirm(event.target.name === "yes");
  // };

  // const loadingTitles = props.isLoading ? "Emails Sending..." : "Notify Users About Modified Closing Date?";
  const loadingTitles = "Are You Sure?";

  const title = isConfirmView ? "Are you sure?" : loadingTitles;

  return (
    <Modal
      maxWidth="sm"
      onClose={handleClose}
      title={title}
      actions={
        <>
          <Button onClick={handleOk} appearance="primary">
            Update
          </Button>
          <Button onClick={handleClose} appearance="subtle">
            Cancel
          </Button>
        </>
      }
    >
      <Box px={3} py={2}>
        <Typography>
          Residents will see the new closing date the next time they visit the 'Community' tab of RoomSync. 
          They will not otherwise be notified of the change.

          We also recommend contacting your residents to let them know of the new closing date as it could catch them by surprise.
        </Typography>
        {/*{isConfirmView && (*/}
        {/*  <>*/}
        {/*    <Typography variant="body2" gutterBottom>*/}
        {/*      Shortening your matching period may catch residents by surprise.*/}
        {/*    </Typography>*/}
        {/*    <br />*/}
        {/*    <Typography variant="body2" gutterBottom>*/}
        {/*      Residents will expect the matching period to close on the date originally shown when they joined RoomSync.*/}
        {/*      Changing the closing date to an earlier date may result in concerns from residents and fewer self-selected*/}
        {/*      matches.*/}
        {/*    </Typography>*/}
        {/*    <br />*/}
        {/*    <br />*/}
        {/*    <Typography variant="body2" gutterBottom>*/}
        {/*      Are you sure you'd like to proceed with this date change?*/}
        {/*    </Typography>*/}
        {/*    <Typography variant="body2" gutterBottom>*/}
        {/*      <strong>You will have the option to notify users of this date change on the next step.</strong>*/}
        {/*    </Typography>*/}
        {/*    <Radio name="yes" isChecked={isConfirm} label="Yes, I'm sure" onChange={handleConfirmChange} />*/}
        {/*    <Radio name="no" isChecked={!isConfirm} label="Nevermind" onChange={handleConfirmChange} />*/}
        {/*  </>*/}
        {/*)}*/}
        {/*{props.isLoading && !isConfirmView && (*/}
        {/*  <>*/}
        {/*    <Typography gutterBottom>*/}
        {/*      Please keep the screen open while we process your email notifications. This could take up to 5 minutes,*/}
        {/*      depending on the numbers of users.*/}
        {/*    </Typography>*/}
        {/*    <br />*/}
        {/*    <Progress type="linear" />*/}
        {/*  </>*/}
        {/*)}*/}
        {/*{!props.isLoading && !isConfirmView && (*/}
        {/*  <>*/}
        {/*    <Typography variant="body2" gutterBottom>*/}
        {/*      You have modified the closing date for a matching group. RoomSync can send a notification to your users to*/}
        {/*      let them know about the new closing date. Notifications are sent to users via e-mail and mobile push. The*/}
        {/*      contents of this notification are below:*/}
        {/*    </Typography>*/}
        {/*    <br />*/}
        {/*    <Typography variant="body2" gutterBottom>*/}
        {/*      <strong>Email subject:</strong> Your RoomSync matching dates have changed*/}
        {/*    </Typography>*/}
        {/*    <Typography variant="body2" gutterBottom>*/}
        {/*      <strong>Email body:</strong> Your community's administrator has modified your matching period's closing*/}
        {/*      date. Your matching period now closes at the end of the day on {props.date?.format("MM/DD/YYYY")}.*/}
        {/*    </Typography>*/}
        {/*    <Typography variant="body2" gutterBottom>*/}
        {/*      <strong>Mobile push:</strong> Your matching period end date has changed!*/}
        {/*    </Typography>*/}
        {/*    <br />*/}
        {/*    <br />*/}
        {/*    <Typography variant="body2" gutterBottom>*/}
        {/*      Would you like RoomSync to notify users about this modified closing date?*/}
        {/*    </Typography>*/}
        {/*    <Typography variant="body2" gutterBottom>*/}
        {/*      <strong>Subnetwork to Notify:</strong> {props.l2Name} ({props.usersInNetwork}{" "}*/}
        {/*      {props.usersInNetwork === 1 ? "user" : "users"})*/}
        {/*    </Typography>*/}
        {/*    <Radio name="yes" isChecked={notify} label="Yes, notify users" onChange={handleNotifyChange} />*/}
        {/*    <Radio name="no" isChecked={!notify} label="No, don't notify users" onChange={handleNotifyChange} />*/}
        {/*  </>*/}
        {/*)}*/}
      </Box>
    </Modal>
  );
};
